import { render, staticRenderFns } from "./RedirectSubscription.vue?vue&type=template&id=18f6b5d3&"
import script from "./RedirectSubscription.vue?vue&type=script&lang=js&"
export * from "./RedirectSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f6b5d3')) {
      api.createRecord('18f6b5d3', component.options)
    } else {
      api.reload('18f6b5d3', component.options)
    }
    module.hot.accept("./RedirectSubscription.vue?vue&type=template&id=18f6b5d3&", function () {
      api.rerender('18f6b5d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RedirectSubscription.vue"
export default component.exports